import { useCallback, useState } from 'react'
import { RIGHT_PANEL_IDS } from '../constants/panel-ids'

interface UseRightPanelStateInput {
  isMobile: boolean
  onPanelActivate?: () => void
  onPanelOpened?: () => void
}

/** Which right-side panel is showing, and the rail's open/close/switch actions. */
export function useRightPanelState({
  isMobile,
  onPanelActivate,
  onPanelOpened,
}: UseRightPanelStateInput) {
  // Right panel default: closed
  const [isOpen, setIsOpen] = useState(false)
  const [activePanel, setActivePanel] = useState<string | null>(null)

  const closePanel = useCallback(() => {
    setIsOpen(false)
    setActivePanel(null)
  }, [])

  // Toolbar icon behavior: re-click same icon to close the right panel
  const selectPanel = (panel: string) => {
    onPanelActivate?.()

    if (isOpen && activePanel === panel) {
      closePanel()
      return
    }

    setActivePanel(panel)
    if (!isOpen) {
      setIsOpen(true)
    }

    onPanelOpened?.()
  }

  // The rail's top toggle button
  const toggleOpen = () => {
    const wasClosed = !isOpen

    if (isMobile) {
      setIsOpen((prev) => !prev)
      if (!isOpen && !activePanel) {
        setActivePanel(RIGHT_PANEL_IDS.photos)
      }
    } else {
      setIsOpen((prev) => {
        const next = !prev

        if (next) {
          setActivePanel(RIGHT_PANEL_IDS.photos)
        } else {
          setActivePanel(null)
        }

        return next
      })
    }

    if (wasClosed) {
      onPanelOpened?.()
    }
  }

  return { isOpen, setIsOpen, activePanel, setActivePanel, closePanel, selectPanel, toggleOpen }
}
